export const cmvReport = {
	label: "CMV",
	description:
		"El Costo de Mercancía Vendida (CMV) es el costo total incurrido para adquirir mercancías que fueron vendidas durante un determinado período de tiempo. Es esencial para determinar la ganancia bruta de una empresa.",
	export: "Descargar en Excel",
	periodInfo: "Mostrando informe de {{since}} hasta {{until}}",
	columns: {
		product: "Producto",
		category: "Categoría",
		quantity: "Cantidad",
		fiscalCode: "SKU",
		ncm: "NCM",
		count: "Cantidad",
		unitValue: "Valor unitario",
		totalValue: "Valor total",
		productUnitCost: "Costo unitario",
		totalCost: "Costo Total",
		percentageCost: "Costo porcentual",
		margin: "Margen",
		empty: "¡Ningún producto encontrado!",
		total: "Total",
		totalProduct: "Total ({{product}})",
	},
	forms: {
		cmvType: "Productos mostrados",
		cmvType1: "Todos los productos",
		cmvType2: "Solo productos del place",
		cmvType3: "Solo productos del vendor",
		search: "Categoría",
		searchPlaceholder: "Busque por categoría",
		period: "Período",
		product: "Producto",
		productPlaceholder: "Busque por producto",
	},
	infoCards: {
		updated: "Actualizado",
		titleCard1: "Cantidad de productos",
		titleCard2: "Valor total",
		titleCard3: "Costo total",
		titleCard4: "Margen porcentual",
		titleCard5: "Margen",
		titleCard6: "Costo unitario cero",
		titleCard6Action: "Ver todos",
	},
	sheet: {
		title: "Informe de CMV",
		fileName: "informe_cmv",
		product: "Producto",
		fiscalCode: "SKU",
		ncm: "NCM",
		count: "Cantidad",
		unitValue: "Valor unitario",
		totalValue: "Valor total",
		productUnitCost: "Costo unitario",
		totalCost: "Costo Total",
		margin: "Margen",
	},
	expandIcon: {
		arrowUp: "Ver productos",
		arrowDown: "Cerrar productos",
	},
	expandedTable: {
		loading: "Cargando",
		columns: {
			product: "Producto",
			codeProduct: "SKU",
			quantity: "Cantidad",
			lostQuantity: "Pérdidas",
			unitValue: "Valor unitario",
			totalValue: "Valor total",
			unitCost: "Costo unitario",
			totalCost: "Costo total",
			percentMargin: "Margen porcentual",
			cmv: "CMV",
			margin: "Margen",
			supplie: "Insumo",
		},
	},
};
